import React from 'react';

const testIds = {
    MOBILE_PLAY_ICON: 'MOBILE_PLAY_ICON'
};

const MobilePlayButton = (props: any) => (
    <svg
        data-test-id={testIds.MOBILE_PLAY_ICON}
        {...props}
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="#F9FAFA" d="M5 2v28l22-14L5 2z" />
    </svg>
);

export {MobilePlayButton};
